import { ApplicationRef } from '@angular/core';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { AttributionAbsoluteModule } from 'SecuritiesApp/ts/features/attribution-absolute/attribution-absolute.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { AttributionAbsoluteComponent } from 'SecuritiesApp/ts/features/attribution-absolute/components/attribution-absolute.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
export class MutualFundsAttributionAbsoluteAppModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(AttributionAbsoluteComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
    }
}
MutualFundsAttributionAbsoluteAppModule.ɵfac = function MutualFundsAttributionAbsoluteAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsAttributionAbsoluteAppModule)(); };
MutualFundsAttributionAbsoluteAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsAttributionAbsoluteAppModule });
MutualFundsAttributionAbsoluteAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, AttributionAbsoluteModule] });
